module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object3d', {
    attrs: {
      "position": _vm.pos
    }
  }, [(_vm.body) ? _c('div', [_c('mesh', {
    attrs: {
      "obj": _vm.body
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.detonation1,
      "position": {
        x: 5,
        z: 0.8
      }
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.detonation2,
      "position": {
        x: -5,
        z: 0.8
      }
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.shoot1,
      "position": {
        x: 5,
        z: 2.6
      }
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.shoot2,
      "position": {
        x: -5,
        z: 2.6
      }
    }
  }), _vm._v(" "), _c('animation', {
    attrs: {
      "fn": _vm.animate
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b94cbcf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/SF03.vue
// module id = 160
// module chunks = 1